// extracted by mini-css-extract-plugin
export default {"wrapper":"tv-z","button":"uv-z","alternate":"vv-z","disabled":"wv-z","paymentWarning":"xv-z","fadeIn":"yv-z"};